import Vue from "vue";

import "../css/index.css";

import "./inline-attachment";
import "./codemirror-4.inline-attachment";

import App from "./App.js";
import ClubApi from "./common/api.service.js";
import { pluralize } from "./common/utils.js";
import { handleCommentThreadCollapseToggle } from "./common/comments.js";
import "./common/toggle.js";
import "./common/records.js";
import "./common/moderation.js";
import vSelect from "vue-select";

Vue.component("post-upvote", () => import("./components/PostUpvote.vue"));
Vue.component("post-bookmark", () => import("./components/PostBookmark.vue"));
Vue.component("post-rsvp", () => import("./components/PostRSVP.vue"));
Vue.component("competition-rsvp", () => import("./components/CompetitionRSVP.vue"));
Vue.component("post-toc", () => import("./components/PostToC.vue"));
Vue.component("comment-upvote", () => import("./components/CommentUpvote.vue"));
Vue.component("record-upvote", () => import("./components/RecordUpvote.vue"));
Vue.component("user-tag", () => import("./components/UserTag.vue"));
Vue.component("people-map", () => import("./components/PeopleMap.vue"));
Vue.component("user-avatar-input", () => import("./components/UserAvatarInput.vue"));
Vue.component("stripe-checkout-button", () => import("./components/StripeCheckoutButton.vue"));
Vue.component("input-length-counter", () => import("./components/InputLengthCounter.vue"));
Vue.component("friend-button", () => import("./components/FriendButton.vue"));
Vue.component("comment-scroll-arrow", () => import("./components/CommentScrollArrow.vue"));
Vue.component("comment-markdown-editor", () => import("./components/MarkdownEditor/MarkdownEditor.vue"));
Vue.component("toggle", () => import("./components/Toggle.vue"));
Vue.component("v-select", vSelect);
Vue.component("tag-select", () => import("./components/TagSelect.vue"));
Vue.component("simple-select", () => import("./components/SimpleSelect.vue"));
Vue.component("reply-form", () => import("./components/ReplyForm.vue"));
Vue.component("theme-switcher", () => import("./components/ThemeSwitcher.vue"));
Vue.component("location-select", () => import("./components/LocationSelect.vue"));
Vue.component("time-input", () => import("./components/TimeInput.vue"));
Vue.component("snowflakes", () => import("./components/Snowflakes.vue"));
Vue.component("clicker", () => import("./components/Clicker.vue"));

// Since our pages have user-generated content, any fool can insert "{{" on the page and break it.
// We have no other choice but to completely turn off template matching and leave it on only for components.
const noDelimiter = { replace: function () {} };

new Vue({
    el: "#app",
    delimiters: [noDelimiter, noDelimiter], // disable templates
    created() {
        App.onCreate();
    },
    mounted() {
        App.onMount();
    },
    data: {
        shownWindow: null,
        replyTo: null,
    },
    methods: {
        toggleCommentThread(event) {
            const comment = event.target.closest(".reply") || event.target.closest(".comment");
            if (comment === null) {
                return;
            }

            // toggle thread visibility
            const collapseItems = comment.querySelectorAll(".thread-collapse-toggle");
            for (let i = 0; i < collapseItems.length; i++) {
                const isVisible = window.getComputedStyle(collapseItems[i]).display !== "none";
                collapseItems[i].style.display = isVisible ? "none" : null;
            }

            // show/hide placeholder with thread length
            const collapseStub =
                comment.querySelector(".comment-collapse-stub") || comment.querySelector(".reply-collapse-stub");
            const wasCollapsed = collapseStub.style.display !== "block";
            collapseStub.style.display = wasCollapsed ? "block" : "none";
            const threadLength = comment.querySelectorAll(".reply").length + 1;
            const pluralForm = pluralize(threadLength, ["комментарий", "комментария", "комментариев"]);
            collapseStub.querySelector(".thread-collapse-length").innerHTML = `${threadLength} ${pluralForm}`;

            handleCommentThreadCollapseToggle(wasCollapsed, comment.id);
            // scroll back to comment if it's outside of the screen
            const commentPosition = comment.getBoundingClientRect();
            if (commentPosition.top < 0) {
                window.scrollBy(0, commentPosition.top);
            }
        },
        toggleCoachParticipants(event) {
            const block = event.target.closest(".coach-participants-block");
            if (block === null) {
                return;
            }

            const content = block.querySelector(".coach-participants-content");
            const icon = block.querySelector(".coach-participants-icon");
            
            if (content && icon) {
                const isVisible = window.getComputedStyle(content).display !== "none";
                content.style.display = isVisible ? "none" : null;
                icon.className = isVisible ? "fas fa-angle-right coach-participants-icon" : "fas fa-angle-down coach-participants-icon";
            }
        },
        showReplyForm(commentId, username, draftKey) {
            this.replyTo = { commentId, username, draftKey };
        },
    },
});

// Отдельный инстанс для футера
new Vue({
    el: "#footer",
});

// Sport team slider functionality
document.addEventListener("DOMContentLoaded", function() {
    const sliderContainers = document.querySelectorAll(".sport-team-slider-container");
    
    sliderContainers.forEach(container => {
        const slides = container.querySelectorAll(".sport-team-slide");
        const dots = container.querySelectorAll(".sport-team-slider-dot");
        const prevBtn = container.querySelector(".sport-team-slider-prev");
        const nextBtn = container.querySelector(".sport-team-slider-next");
        let currentSlide = 0;

        if (slides.length <= 1) return;

        function showSlide(index) {
            slides.forEach(slide => slide.classList.remove("active"));
            dots.forEach(dot => dot.classList.remove("active"));
            
            slides[index].classList.add("active");
            dots[index].classList.add("active");
            currentSlide = index;
        }

        function nextSlide() {
            const next = (currentSlide + 1) % slides.length;
            showSlide(next);
        }

        function prevSlide() {
            const prev = (currentSlide - 1 + slides.length) % slides.length;
            showSlide(prev);
        }

        // Dot click handlers
        dots.forEach((dot, index) => {
            dot.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                showSlide(index);
            });
        });

        // Button click handlers
        if (prevBtn) {
            prevBtn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                prevSlide();
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                nextSlide();
            });
        }

        // Container click to go to next slide (excluding controls)
        container.addEventListener("click", (e) => {
            if (!e.target.closest(".sport-team-slider-controls")) {
                nextSlide();
            }
        });
    });

    // Coach team slider functionality (compact version)
    const coachSliderContainers = document.querySelectorAll(".coach-team-slider-container");
    
    coachSliderContainers.forEach(container => {
        const slides = container.querySelectorAll(".coach-team-slide");
        const dots = container.querySelectorAll(".coach-team-slider-dot");
        const prevBtn = container.querySelector(".coach-team-slider-prev");
        const nextBtn = container.querySelector(".coach-team-slider-next");
        let currentSlide = 0;
        let autoSlideInterval;

        if (slides.length <= 1) return;

        function showSlide(index) {
            slides.forEach(slide => slide.classList.remove("active"));
            dots.forEach(dot => dot.classList.remove("active"));
            
            slides[index].classList.add("active");
            dots[index].classList.add("active");
            currentSlide = index;
        }

        function nextSlide() {
            const next = (currentSlide + 1) % slides.length;
            showSlide(next);
        }

        function prevSlide() {
            const prev = (currentSlide - 1 + slides.length) % slides.length;
            showSlide(prev);
        }

        function startAutoSlide() {
            stopAutoSlide();
            autoSlideInterval = setInterval(nextSlide, 3500);
        }

        function stopAutoSlide() {
            if (autoSlideInterval) {
                clearInterval(autoSlideInterval);
            }
        }

        // Dot click handlers
        dots.forEach((dot, index) => {
            dot.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                showSlide(index);
                stopAutoSlide();
                setTimeout(startAutoSlide, 5000);
            });
        });

        // Button click handlers
        if (prevBtn) {
            prevBtn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                prevSlide();
                stopAutoSlide();
                setTimeout(startAutoSlide, 5000);
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                nextSlide();
                stopAutoSlide();
                setTimeout(startAutoSlide, 5000);
            });
        }

        // Container click to go to next slide (excluding buttons, dots and slides)
        container.addEventListener("click", (e) => {
            if (!e.target.closest(".coach-team-slider-btn") && 
                !e.target.closest(".coach-team-slider-dots") && 
                !e.target.closest(".coach-team-slide")) {
                nextSlide();
                stopAutoSlide();
                setTimeout(startAutoSlide, 5000);
            }
        });

        // Start auto-sliding
        startAutoSlide();

        // Pause on hover
        container.addEventListener("mouseenter", stopAutoSlide);
        container.addEventListener("mouseleave", startAutoSlide);
    });

    // Auto-expand coach participants block if URL hash points to it
    if (window.location.hash === "#coach-participants") {
        const participantsBlock = document.getElementById("coach-participants");
        if (participantsBlock) {
            const content = participantsBlock.querySelector(".coach-participants-content");
            const icon = participantsBlock.querySelector(".coach-participants-icon");
            
            if (content && icon) {
                content.style.display = null; // Ensure it's expanded
                icon.className = "fas fa-angle-down coach-participants-icon";
            }
            
            // Scroll to the block after a short delay to ensure page is loaded
            setTimeout(() => {
                participantsBlock.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 300);
        }
    }

    // Prevent page scroll when scrolling inside people filters section content
    const peopleFiltersContents = document.querySelectorAll(".people-filters-section-content");
    peopleFiltersContents.forEach(content => {
        content.addEventListener("wheel", function(e) {
            const isScrollingDown = e.deltaY > 0;
            const isScrollingUp = e.deltaY < 0;
            const isAtTop = this.scrollTop === 0;
            const isAtBottom = this.scrollTop + this.clientHeight >= this.scrollHeight - 1;

            // Prevent page scroll if:
            // - scrolling down and not at bottom, OR
            // - scrolling up and not at top
            if ((isScrollingDown && !isAtBottom) || (isScrollingUp && !isAtTop)) {
                e.stopPropagation();
            }
        }, { passive: false });
    });
});

window.togglePeopleFiltersSection = function(headerElement) {
    const section = headerElement.closest(".people-filters-section");
    if (section) {
        section.classList.toggle("collapsed");
    }
};
